import {Basic} from '@packages/systems/core/plugins';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {Atom} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Trial Text',
  showEmpty: false,
  constraints: {
    ancestors: [
      {is: 'CommerceCheckoutOrderItem', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutOrderItemOptionList', rule: 'Forbid'},
      {is: 'CommerceCheckoutOrderItemOptionListItem', rule: 'Forbid'},
      {is: 'CommerceCheckoutOrderItemOptionListItemLabel', rule: 'Forbid'},
      {is: 'CommerceCheckoutOrderItemOptionListItemValue', rule: 'Forbid'},
      {is: 'CommerceCheckoutOrderItemTrialTextWrapper', rule: 'Forbid'},
    ],
  },
  render: Atom.getConfigShape(Basic.atoms.Block).render,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'block',
        },
      },
    },
  },
  fields: {children: TListOfElement},
});

export default config;
